module.exports = __webpack_public_path__ + "static/img/zhihui-2.a802076.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhihui-2.png
// module id = X339
// module chunks = 36